import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "igfy-layout" }
const _hoisted_2 = { class: "top-bar flex justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "brand" }, "Fillup Mart", -1)
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { class: "px-2 inline-block" }
const _hoisted_6 = { class: "px-2 inline-block" }
const _hoisted_7 = { class: "px-2 inline-block" }
const _hoisted_8 = { class: "post" }
const _hoisted_9 = { class: "top-section flex justify-content-between align-items-center p-2" }
const _hoisted_10 = { class: "author" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "username pl-2" }
const _hoisted_13 = { class: "p-2" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "bottom-section p-2" }
const _hoisted_16 = { class: "actions flex justify-content-between my-2" }
const _hoisted_17 = { class: "left-section flex" }
const _hoisted_18 = { class: "px-2" }
const _hoisted_19 = { class: "px-2" }
const _hoisted_20 = { class: "px-2" }
const _hoisted_21 = { class: "right-section" }
const _hoisted_22 = { class: "px-2" }
const _hoisted_23 = { class: "engagement mt-2 mb-1" }
const _hoisted_24 = { class: "likes flex align-items-center" }
const _hoisted_25 = { class: "avatars" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "stat pl-2" }
const _hoisted_28 = { class: "text-left" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Liked by ")
const _hoisted_30 = { class: "font-bold" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" and ")
const _hoisted_32 = { class: "font-bold" }
const _hoisted_33 = { class: "comments flex align-items-start mt-2" }
const _hoisted_34 = { class: "date text-left" }
const _hoisted_35 = { class: "bottom-nav" }
const _hoisted_36 = { class: "flex justify-content-around" }
const _hoisted_37 = { class: "nav-icon" }
const _hoisted_38 = { class: "nav-icon" }
const _hoisted_39 = { class: "nav-icon" }
const _hoisted_40 = { class: "nav-icon" }
const _hoisted_41 = { class: "nav-icon" }
const _hoisted_42 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddIcon = _resolveComponent("AddIcon")!
  const _component_HeartIcon = _resolveComponent("HeartIcon")!
  const _component_MessengerIcon = _resolveComponent("MessengerIcon")!
  const _component_MoreIcon = _resolveComponent("MoreIcon")!
  const _component_CommentIcon = _resolveComponent("CommentIcon")!
  const _component_ShareIcon = _resolveComponent("ShareIcon")!
  const _component_BookmarkIcon = _resolveComponent("BookmarkIcon")!
  const _component_HomeIcon = _resolveComponent("HomeIcon")!
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_ReelsIcon = _resolveComponent("ReelsIcon")!
  const _component_ShopIcon = _resolveComponent("ShopIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_AddIcon)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_HeartIcon)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_MessengerIcon)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("img", {
            class: "avatar",
            src: _ctx.author.avatar
          }, null, 8, _hoisted_11),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.author.username), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_MoreIcon)
        ])
      ]),
      _createElementVNode("img", {
        class: "picture",
        src: _ctx.post.picture
      }, null, 8, _hoisted_14),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_HeartIcon)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_CommentIcon)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_ShareIcon)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_BookmarkIcon)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.likes.avatars, (avatar, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "avatar",
                  key: index
                }, [
                  _createElementVNode("img", { src: avatar }, null, 8, _hoisted_26)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("p", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.likes.firstUserName), 1),
                _hoisted_31,
                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.likes.numberOfOtherLikes) + " others", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, "View all " + _toDisplayString(_ctx.numberWithCommas(_ctx.numberOfComments)) + " comments", 1)
        ]),
        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.dayjs(_ctx.post.date).format("MMMM D")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_HomeIcon, {
            width: "100%",
            height: "100%"
          })
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_SearchIcon, {
            width: "100%",
            height: "100%"
          })
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_ReelsIcon, {
            width: "100%",
            height: "100%"
          })
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createVNode(_component_ShopIcon, {
            width: "100%",
            height: "100%"
          })
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("img", {
            class: "profile-avatar",
            src: _ctx.profileAvatar,
            alt: "profile-avatar"
          }, null, 8, _hoisted_42)
        ])
      ])
    ])
  ]))
}